import { Modal } from "react-bootstrap";
import "./Successfull_horizontal_Modal.css";

const Successfull_horizontal_Modal = (props) => {
  setTimeout(() => {
    props?.onHide();
  }, 5000);

  return (
    <section className="Successfull_horizontal_Modal ">
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="Successfull_horizontal_Modal modal-holder "
      >
        <Modal.Header closeButton> </Modal.Header>
        <Modal.Body>
          <div className="animation_holder">{props?.lottie}</div>

          <div className="text_holder">
            <h6>{props?.message}</h6>
            <p>{props?.subMessage}</p>
          </div>

         
        </Modal.Body>
      </Modal>
    </section>
  );
};

export default Successfull_horizontal_Modal;
